import classNames from 'classnames';
import classes from './app-text.module.scss';

// font can be : 'small' | 'medium' | 'large' | 'regular' (default: 'regular')
export function AppTitle({ className, font, children, ...props }) {
    return (
        <h3 className={classNames(classes.appTitle, font && classes[font], className)} {...props}>
            {children}
        </h3>
    );
}

export function AppText({ className, weight, dark, children, font, ...props }) {
    return (
        <p
            className={classNames(
                classes.appText,
                dark && classes.appTextDark,
                font && classes[font],
                className
            )}
            {...props}
            style={{ fontWeight: weight, ...props.style }}
        >
            {children}
        </p>
    );
}
